import { IncentiveCategory } from '@varo/graphql-schema-types';
import { resolveIncentiveContent } from 'features/incentive/content/resolveIncentiveContent';
import useCurrentIncentives from 'features/incentive/hooks/useCurrentIncentives';

const useIncentiveProgram = (
  incentiveType: IncentiveCategory,
  incentiveProgramId: string,
) => {
  const { incentives, fetching, error, incentivesError, refresh } =
    useCurrentIncentives(incentiveType);

  const program = incentives?.find(
    (incentive) => incentive.id === incentiveProgramId,
  );
  const content = program ? resolveIncentiveContent(program) : undefined;

  return { program, content, fetching, error, incentivesError, refresh };
};

export default useIncentiveProgram;
